// :cow: Cosmose CONFIDENTIAL :iso:
import { Action, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { authReducer, State } from '@coa/app/auth/store/auth.reducer';
import { loggedOut } from '@coa/app/auth/store/auth.actions';

export interface RootState {
  auth: State;
}

export const rootReducers: ActionReducerMap<RootState> = {
  auth: authReducer,
};

export function clearState(reducer: any) {
  return (state: any, action: Action) => {
    if (action.type === loggedOut.type) {
      state = undefined;
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearState];
